export const STAGE_OPTIONS = [
  "not_contacted",
  "queued",
  "contacted",
  "replied",
  "qualified",
  "meeting_booked",
  "won",
  "lost",
  "do_not_contact",
];

export const STAGE_LABELS = {
  not_contacted: "Not contacted",
  queued: "Queued",
  contacted: "Contacted",
  replied: "Replied",
  qualified: "Qualified",
  meeting_booked: "Meeting booked",
  won: "Won",
  lost: "Lost",
  do_not_contact: "Do not contact",
};

export const ENROLLMENT_OPTIONS = [
  "active",
  "paused",
  "completed",
  "unsubscribed",
  "bounced",
];

export const ENROLLMENT_LABELS = {
  active: "Active",
  paused: "Paused",
  completed: "Completed",
  unsubscribed: "Unsubscribed",
  bounced: "Bounced",
};

export const IMPORT_FIELDS = [
  { key: "email", label: "Email", required: true, type: "email" },
  { key: "company_name", label: "Company", required: false, type: "text" },
  { key: "website", label: "Website", required: false, type: "url" },
  { key: "owner_name", label: "Owner", required: false, type: "text" },
  { key: "phone", label: "Phone", required: false, type: "phone" },
  { key: "first_name", label: "First name", required: false, type: "text" },
  { key: "last_name", label: "Last name", required: false, type: "text" },
  { key: "title", label: "Title", required: false, type: "text" },
  { key: "tags", label: "Tags", required: false, type: "text" },
  { key: "city", label: "City", required: false, type: "text" },
  { key: "state", label: "State", required: false, type: "text" },
];

// Default time of day (24h) when a step has no explicit sendAtHour set.
export const DEFAULT_SEND_HOUR = 9;
export const DEFAULT_SEND_MINUTE = 0;

// Default sequence copy uses {{var|fallback}} syntax so a missing merge value
// produces natural text instead of "Hi ," holes. Copy intentionally avoids
// marketing cues (ALL CAPS, "FREE", "100% guaranteed", heavy emoji) that
// escalate spam scores.
export const DEFAULT_SEQUENCE = [
  {
    stepIndex: 0,
    name: "Intro",
    subject: "Quick question{{company_name| for your team}}",
    body:
      "<p>Hi {{first_name|there}},</p>" +
      "<p>I help {{company_name|teams like yours}} with Bellhopt. Worth a short look?</p>" +
      "<p>Happy to share more if useful.</p>",
    delayDays: 0,
    sendAtHour: 9,
    sendAtMinute: 0,
    businessDaysOnly: true,
    enabled: true,
  },
  {
    stepIndex: 1,
    name: "Follow up 1",
    subject: "Re: quick question{{company_name| for your team}}",
    body:
      "<p>Hi {{first_name|there}},</p>" +
      "<p>Bumping this up — let me know if it's worth a quick look or if I should circle back later.</p>",
    delayDays: 3,
    sendAtHour: 10,
    sendAtMinute: 30,
    businessDaysOnly: true,
    enabled: true,
  },
  {
    stepIndex: 2,
    name: "Follow up 2",
    subject: "Closing the loop",
    body:
      "<p>Hi {{first_name|there}},</p>" +
      "<p>Last note from me on this — happy to pick it back up whenever the timing is better. Just reply here.</p>",
    delayDays: 7,
    sendAtHour: 9,
    sendAtMinute: 30,
    businessDaysOnly: true,
    enabled: true,
  },
];

// Tracking is intentionally hard-off. Open/click tracking has been removed
// from the product. Only unsubscribe (compliance) remains.
export const ENFORCED_TRACKING = Object.freeze({
  clickTrackingEnabled: false,
  openTrackingEnabled: false,
  unsubscribeEnabled: true,
});

export const SMART_VIEWS = [
  {
    key: "today",
    label: "Today",
    description: "Due now + overdue follow-ups",
    badgeTone: "danger",
  },
  {
    key: "replies",
    label: "Replies",
    description: "Inbound replies from hosts",
    badgeTone: "success",
  },
  {
    key: "followups",
    label: "Follow-ups",
    description: "Scheduled outreach grouped by day",
    badgeTone: "primary",
  },
  {
    key: "queue",
    label: "Send queue",
    description: "Pending outbound to review",
    badgeTone: "info",
  },
  {
    key: "all",
    label: "All leads",
    description: "Full ledger with filters",
    badgeTone: "default",
  },
];

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
export const URL_REGEX = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(\/.*)?$/i;
export const PHONE_REGEX = /^[+\d][\d\s().-]{6,}$/;
